<template>
  <div class="orderDetail">
    <div v-if="$store.state.isMobile">
      <div v-if="type == 'cancel'" class="topTitle">请选择需要取消的人员</div>
      <personalCard v-for="(item, index) in members" :key="item.id">
        <div slot="left" :class="`leftName ${type != 'cancel' ? 'canceled' : ''}`">
          <el-checkbox v-model="item.checked" v-if="type == 'cancel'"></el-checkbox>
          <div v-else class="index">{{index + 1}}</div>
        </div>
        <div slot="right" class="rightContent">
          <div class="detail">
            <span class="title">姓名</span>
            <span class="name">{{item.personName}}</span>
          </div>
          <div class="detail" v-if="item.cardNum">
            <span class="title">证件号码</span>
            <span class="name">{{item.cardNum}}</span>
          </div>
          <div class="detail" v-if="item.personType == 3 && !item.cardNum">
            <span class="title">年龄</span>
            <span class="name">{{item.age}}</span>
          </div>
        </div>
      </personalCard>
      <div class="buttonNormal" @click="clickButton">{{type == 'look' ? '返回' : '确认取消'}}</div>
    </div>
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <div class="pcItemCard">
          <div class="itemTitle" v-if="type == 'cancel'">请选择需要取消的人员</div>
          <div class="personals">
            <personalCard v-for="(item, index) in members" :key="index">
              <div slot="left" :class="`leftName ${type != 'cancel' ? 'canceled' : ''}`">
                <el-checkbox v-model="item.checked" v-if="type == 'cancel'"></el-checkbox>
                <div v-else class="index">{{index + 1}}</div>
              </div>
              <div slot="right" class="rightContent">
                <div class="detail">
                  <span class="title">姓名</span>
                  <span class="name">{{item.personName}}</span>
                </div>
                <div class="detail" v-if="item.cardNum">
                  <span class="title">证件号码</span>
                  <span class="name">{{item.cardNum}}</span>
                </div>
                <div class="detail" v-if="item.personType == 3 && !item.cardNum">
                  <span class="title">年龄</span>
                  <span class="name">{{item.age}}</span>
                </div>
              </div>
            </personalCard>
          </div>
          <!-- <el-pagination
            background
            layout="pager"
            :page-size="10"
            :current-page="currentPage"
            :total="total">
          </el-pagination> -->
        </div>
      </div>
      <div class="buttonsWarp">
        <div class="button4" @click="toIndex">返回主页</div>
        <div class="button3" @click="clickButton" v-if="type == 'cancel'">确定取消</div>
      </div>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcContent'"  v-if="showPop">
      <pop>
        <slot>
          <div class="confirmText">{{popContent}}</div>
          <div class="buttonsWarp">
            <div class="buttonCancel" @click="cancel">取消</div>
            <div class="buttonConfirm" @click="confirm">确定</div>
          </div>
        </slot>
      </pop>
    </div>
    <pop v-if="showCancelChildPop">
      <slot>
        <div :class="`popContent ${!$store.state.isMobile ? 'pcPopContent' : ''}`">
          <div class="notice">您选择了取消当前登录账户的预约信息，是否一起取消该账户下预约的儿童订单？</div>
        </div>
        <div class="buttonsWarp">
          <div class="buttonConfirm shareButton" @click="cancelFun()">否</div>
          <div class="buttonCancel shareButton" @click="cancelFun(true)">是</div>
        </div>
      </slot>
    </pop>
  </div>
</template>

<script>
import personalCard from '../../components/common/personalCard.vue'
import pop from '../../components/common/pop.vue'
import topBanner from '../../components/common/topBanner'
export default {
  data() {
    return {
      type: '',
      members: [],
      showPop: false,
      total: 20,
      currentPage: 1,
      orderDetail: {},
      popContent: '',
      tips: {},
      showCancelChildPop: false,
      cancelData: ''
    };
  },

  components: {personalCard, pop, topBanner},

  methods: {
    clickButton() {
      this.popContent = ''
      if (this.type == 'look') {
        this.$router.back(-1)
      } else {
        let cancelData = this.members.filter((item) => {return item.checked})
        if (!cancelData.length) return this.$message.error('请选择要取消的人员')
        this.$ajax(`/api/ticket/front/order/count?museumCode=${this.$store.state.museumCode}`).then((res) => {
          if (res.data.cancelCount == this.tips.limitCountDay || res.data.cancelCount == this.tips.limitCountDay - 1) {
            this.popContent = `您当日已取消${res.data.cancelCount}次，`
          }
        })
        var pat =/(\d{3})\d*(\d{4})/;
        if (cancelData.find((item) => {return item.phone.replace(pat,'$1****$2') == this.$cookie.get('ticket_phone')}) && isNaN(Number(this.$route.query.museumCode))) {
          this.popContent += '取消当前登录用户，本订单将无效，是否确定取消？'
        } else {
          this.tips.cancelTip ? this.popContent += this.tips.cancelTip : ''
        }
        if (!this.popContent) return this.confirm()
        this.showPop = true
      }
    },

    cancel() {
      this.showPop = false
    },

    confirm() {
      this.cancelData = this.members.filter((item) => {return item.checked}).map((item) => {return item.id}).join(',')
      if (!isNaN(Number(this.$route.query.museumCode))) {
        let cancelChild = false
        if (this.$route.query.orderType == 1 && this.orderDetail.belongNum && this.orderDetail.childOn && this.members.find((item)=>{return item.checked && !item.belongId})) { //勾选了取消账户本人
          return this.showCancelChildPop = true
        }
        return this.cancelFun()
      }
      this.$ajax.put(`/api/ticket/front/order?ticketOrderId=${this.$route.query.orderId}&peopleIds=${this.cancelData}`).then((res) => {
        this.$router.replace(`/ticket/success?type=cancel&museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id }` : ''}${this.$route.query.orderType ? `&orderType=${this.$route.query.orderType}` : ''}`)
      })
    },

    cancelFun(cancelChild) {
      this.showCancelChildPop = false
      this.$ajax.put(`/api/ticket/front/order/cancel?orderId=${this.$route.query.orderId}&peopleIds=${this.cancelData}${cancelChild ? '&cancelChild=true' : ''}`).then((res) => {
        this.$router.replace(`/ticket/success?type=cancel&museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id }` : ''}${this.$route.query.orderType ? `&orderType=${this.$route.query.orderType}` : ''}`)
      })
    },

    toIndex() {
      this.$router.push({path: '/ticket/home', query: this.$route.query})
    },

    getOrderDetail(id) {
      let isFid = !isNaN(Number(this.$route.query.museumCode))
      let url = isFid ? `/api/ticket/front/order/detail-v2?ticketOrderId=${id}` : `/api/ticket/front/order/detail?ticketOrderId=${id}`
      this.$ajax(url).then((res) => {
        this.orderDetail = res.data.ticketOrder
        if (isFid && this.$route.query.type == 'cancel') {
          this.members = res.data.peoples.filter((item)=>{return !item.orderPeople.cancel})
          return
        }
        this.members = res.data.peoples
      })
    },

    getCancelTips() {
      this.$ajax(`/api/ticket/front/black-list-setting?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.tips = res.data || {}
      })
    },
  },

  created() {
    this.type = this.$route.query.type
    this.getOrderDetail(this.$route.query.orderId)
    this.getCancelTips()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.orderDetail{
  .topTitle{
    height: 1.5rem;
    background-color: #f6f6f6;
    line-height: 1.5rem;
    font-size: 0.45rem;
    font-weight: 500;
  }
  .title{
    line-height: 1.2rem;
  }
  .detail{
    line-height: 0.3rem !important;
  }
  .button3{
    margin-left: 0.4rem;
    // margin:auto;
  }
  .pcPop{
    .popDetail{
      width: 3rem;

    }
  }
  .pcPop{
    width: 3.8rem;
    margin: auto 3rem;
    .notice{
      font-size: 30px;
    }
    .shareButton{
      font-size: 30px;
      height: 50px;
      width: 200px;
      line-height: 50px;
      margin-bottom: 0.2rem;
      border-width: 1px;
      margin-top:30px;
    }
  }
}
</style>
<style type="text/css" lang="scss">
  .orderDetail{
    .el-checkbox__inner{
      border-radius: unset !important;
      margin-top: 0.8rem;
    }
    .leftName{
      height: auto !important;
      .index{
        margin-top: 1rem;
        font-size: 0.7rem;
      }
    }
    .popDetail .notice{
      font-size: 0.5rem;
      text-align: left;
    }
    .canceled{
      padding-left: 0.16rem;
      writing-mode: horizontal-tb;
      .index{
        margin-top: 0.7rem;
      }
    }
    .confirmText{
      margin: 0.5rem 0;
      font-size: 0.6rem;
      font-weight: 500;
    }
    .buttonNormal{
      margin-top: 1rem;
    }
    .pcItemCard{
      .personals{
        display: flex;
        // justify-content: space-between;
        .left{
          min-height: 0.1rem;
          // padding: 0.1rem;
          padding-right: 40px;
          width: 100px;
          overflow: hidden;
          &::after{
            width: 5px;
            height: 80%;
            top: 10%;
          }
          .leftName{
            height: auto !important;
            .index{
              font-size: 35px !important;
              margin: auto 0.15rem;
            }
          }
          .canceled{
            padding-left: 0.35rem;
            .index{
              font-size: 35px !important;
            }
          }
          .el-checkbox__inner{
            margin: 30px 15px;
            height: 30px;
            width: 30px;
            border-radius: 3px !important;
          }
          .el-checkbox__inner::after{
            height: 10px;
            width: 6px;
            left: 10px;
            top: 6px;
                  }
        }
        .rightContent{

        }
        .right{
          margin-left: -10px;
          .detail{
            line-height: 50px !important;
            height: 60px !important;
            font-size: 20px;
            .title{
              line-height: 50px;
            }
          }
        }
      }
      .personalCard{
        margin: 30px 0;
      }
      .personalCard:nth-child(2n-1){
        margin-right: 4%;
      }
    }
    .pcPop{
      min-height: 200px !important;
      .buttonsWarp{
        .buttonCancel, .buttonConfirm{
          width: 160px !important;
          height: 52px;
        }
      }
    }
  }
</style>




